let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Vk3e")).then(() => parcelRequire('3xHL2'));